import { render, staticRenderFns } from "./VideoControls.vue?vue&type=template&id=3537fc7d&"
import script from "./VideoControls.vue?vue&type=script&lang=js&"
export * from "./VideoControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3537fc7d')) {
      api.createRecord('3537fc7d', component.options)
    } else {
      api.reload('3537fc7d', component.options)
    }
    module.hot.accept("./VideoControls.vue?vue&type=template&id=3537fc7d&", function () {
      api.rerender('3537fc7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/VideoControls.vue"
export default component.exports